<script>
  import * as langHandler from "@/utils/language-handler.js";
  const domainURL =
    "https://440megatonnes.ca" + (langHandler.locale == "fr" ? "/fr" : "");
</script>

<footer id="colophon" class="site-footer" role="contentinfo">
  <div class="site-footer-inner layout-wrapper">
    <a class="site-footer-logo" href="https://440megatonnes.ca/" rel="home">
      <span class="u-sr-only"
        >440 Megatonnes: Tracking Canada’s path to net zero</span
      >

      <svg
        class="site-logo"
        viewBox="0 0 105 105"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="52.5" cy="52.5" r="52.5" fill="#3B6A73" />
        <g clip-path="url(#clip0_732_3492)">
          <path
            d="M87.2424 30.6636C85.2043 28.7681 82.5309 27.8247 79.2046 27.8247C75.8784 27.8247 73.1962 28.7681 71.1669 30.6636C68.8553 32.8765 67.6995 35.9094 67.6995 39.7357V61.768H61.4616V28.3801H53.9091L38.513 61.768H34.975V28.3801H27.4225L10.5 65.0918V69.3853H27.3431V76.8705H34.9662V69.3853H53.8209V76.8705H61.444V69.3853H68.1494C68.6876 71.4396 69.6846 73.1764 71.1492 74.5782C73.1785 76.4738 75.8607 77.4171 79.187 77.4171C82.5133 77.4171 85.1954 76.4738 87.2247 74.5782C89.5364 72.3653 90.6922 69.3413 90.6922 65.5061V39.7357C90.6922 35.9006 89.5364 32.8765 87.2247 30.6636H87.2424ZM27.3431 61.768H20.4082L27.3431 44.382V61.768ZM53.8209 61.768H46.886L53.8209 44.382V61.768ZM79.1958 71.3426L71.7227 61.9795H76.0813V39.7357C76.0813 38.0694 76.3636 36.9233 76.9195 36.2708C77.4047 35.7154 78.1635 35.4421 79.2046 35.4421C80.2458 35.4421 81.0398 35.7154 81.4898 36.2708C82.0456 36.8704 82.328 38.0253 82.328 39.7357V61.9795H86.6777L79.2046 71.3426H79.1958Z"
            fill="white"
          />
          <path
            d="M79.1957 71.3429L71.7227 61.9798H76.0812V39.736C76.0812 38.0697 76.3635 36.9235 76.9194 36.2711C77.4047 35.7157 78.1634 35.4424 79.2046 35.4424C80.2457 35.4424 81.0397 35.7157 81.4897 36.2711C82.0456 36.8706 82.3279 38.0256 82.3279 39.736V61.9798H86.6776L79.2046 71.3429H79.1957Z"
            fill="#F94144"
          />
        </g>
        <defs>
          <clipPath id="clip0_732_3492">
            <rect
              width="80.201"
              height="49.6012"
              fill="white"
              transform="translate(10.5 27.8247)"
            />
          </clipPath>
        </defs>
      </svg>
    </a>

    <div class="site-footer-links">
      <ul id="menu-footer-menu" class="site-footer-menu">
        <li
          id="menu-item-25"
          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-25"
        >
          <a href="{domainURL}/tracking-440/">{langHandler.getTranslation('nav__tracking_progress')}</a>
          <ul class="sub-menu">
            <li
              id="menu-item-23"
              class="menu-item menu-item-type-post_type menu-item-object-page menu-item-23"
            >
              <a href="{domainURL}/insights/">{langHandler.getTranslation('nav__insights')}</a>
            </li>
            <li
              id="menu-item-895"
              class="menu-item menu-item-type-post_type menu-item-object-page menu-item-895"
            >
              <a href="{domainURL}/data/">{langHandler.getTranslation('nav__data')}</a>
            </li>
          </ul>
        </li>
        <li
          id="menu-item-24"
          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-24"
        >
          <a href="{domainURL}/about/">{langHandler.getTranslation('nav__what_we_do')}</a>
          <ul class="sub-menu">
            <li
              id="menu-item-744"
              class="menu-item menu-item-type-post_type menu-item-object-page menu-item-744"
            >
              <a href="{domainURL}/newsletter-signup/"
                >{langHandler.getTranslation('nav__newsletter')}</a
              >
            </li>
          </ul>
        </li>
      </ul>
      <a class="site-footer-cci-link" href="https://climateinstitute.ca/">
        <span class="u-sr-only">Canadian Climate Institute.</span>

        <svg
          class="site-footer-cci-logo"
          viewBox="0 0 429 104"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M203.8 86.3L202.6 84C204.1 83.3 205.6 82.4 207 81.5L208.4 83.6C207 84.6 205.4 85.5 203.8 86.3M212.6 80.3L211 78.3C212.3 77.1 213.4 76 214.5 74.6L216.5 76.2C215.3 77.8 214 79 212.6 80.3M219.6 72L217.4 70.6C218.3 69.2 219 67.7 219.7 66.1L222 67.1C221.3 68.9 220.5 70.5 219.6 72M223.8 62.1L221.4 61.4C221.9 59.8 222.2 58.2 222.3 56.4L224.8 56.7C224.6 58.5 224.3 60.3 223.8 62.1M222.6 51.4V51.3C222.6 49.6 222.4 48 222.1 46.3L224.6 45.8C224.9 47.5 225.1 49.4 225.1 51.2V51.3H222.6V51.4ZM220.8 41.4C220.3 39.8 219.6 38.2 219 36.8L221.3 35.6C222.1 37.2 222.8 38.9 223.4 40.7L220.8 41.4ZM216.4 32.3C215.5 30.9 214.4 29.5 213.3 28.4L215.1 26.7C216.3 28 217.4 29.5 218.4 31L216.4 32.3V32.3ZM209.6 24.9C208.3 23.9 206.9 22.8 205.4 22L206.7 19.8C208.2 20.7 209.7 21.8 211.1 22.9L209.6 24.9V24.9ZM201 19.7C199.5 19 197.9 18.4 196.3 18.1L197 15.7C198.7 16.2 200.5 16.7 202.1 17.4L201 19.7ZM176.4 18.5L175.6 16.1C177.3 15.5 179.1 15.1 180.9 14.8L181.4 17.3C179.6 17.6 178 18.1 176.4 18.5ZM191.3 17C189.9 16.9 188.5 16.8 187.3 16.8H186.4L186.3 14.3H187.3C188.8 14.3 190.2 14.4 191.7 14.5L191.3 17ZM187.1 73.4C175.4 73.4 166 63.9 166 52.3C166 44.2 170.5 37.3 177.1 33.7L176.2 31.4C168.7 35.3 163.5 43.3 163.5 52.4C163.5 65.4 174.1 76.1 187.2 76.1C189.4 76.1 191.6 75.8 193.7 75.2L192.8 72.9C190.9 73.1 189.1 73.4 187.1 73.4ZM205.3 104.3C206.1 104.1 206.9 103.7 207.7 103.4L204.4 95L202 95.9L205.3 104.3Z"
          />
          <path
            d="M187.1 82.4C170.5 82.4 157 68.9 157 52.3C157 39.6 164.8 28.8 175.9 24.2L171.2 12.2C155.3 18.5 144.1 34 144.1 52.3C144.1 76.1 163.4 95.4 187.2 95.4C192.9 95.4 198.3 94.4 203.1 92.3L198.4 80.3C194.9 81.6 191.2 82.4 187.1 82.4"
          />
          <path
            d="M214.8 52.3C214.8 37.1 202.4 24.6 187.1 24.6C183.5 24.6 180.1 25.3 176.8 26.6L180.6 36.2C182.6 35.4 184.8 34.9 187.1 34.9C196.7 34.9 204.5 42.7 204.5 52.3C204.5 59.6 200 65.9 193.5 68.5L197.3 78.1C207.7 73.8 214.8 63.9 214.8 52.3"
          />
          <path
            d="M166.8 1C166 1.3 165.2 1.7 164.5 2L167.8 10.4C168.6 10.1 169.3 9.7 170.1 9.4L166.8 1ZM21 34.1C19.8 33.4 18.8 32.5 18.1 31.3C17.4 30.1 17 28.8 17 27.3C17 25.8 17.4 24.5 18.1 23.3C18.8 22.1 19.8 21.2 21 20.5C22.2 19.8 23.6 19.5 25.1 19.5C26.2 19.5 27.3 19.7 28.2 20C29.1 20.4 30 20.9 30.6 21.6L29.9 22.3C28.7 21.1 27.1 20.5 25.1 20.5C23.8 20.5 22.6 20.8 21.6 21.4C20.5 22 19.7 22.8 19.1 23.8C18.5 24.8 18.2 26 18.2 27.3C18.2 28.6 18.5 29.7 19.1 30.8C19.7 31.8 20.5 32.7 21.6 33.2C22.7 33.8 23.8 34.1 25.1 34.1C27 34.1 28.6 33.5 29.9 32.2L30.6 32.9C29.9 33.6 29.1 34.1 28.2 34.5C27.2 34.9 26.2 35.1 25.1 35.1C23.6 35.1 22.2 34.8 21 34.1ZM43.6 30.7H34.6L32.6 35.1H31.4L38.5 19.6H39.6L46.8 35H45.6L43.6 30.7V30.7ZM43.2 29.7L39.1 20.7L35 29.7H43.2ZM62.3 19.5V35H61.4L50.8 21.5V35H49.7V19.5H50.7L61.1 33V19.5H62.3V19.5ZM77.3 30.7H68.3L66.3 35.1H65.1L72.2 19.6H73.3L80.5 35H79.3L77.3 30.7V30.7ZM76.8 29.7L72.7 20.7L68.6 29.7H76.8V29.7ZM83.3 19.5H89.4C91 19.5 92.4 19.8 93.7 20.5C94.9 21.2 95.9 22.1 96.6 23.3C97.3 24.5 97.6 25.8 97.6 27.3C97.6 28.8 97.3 30.1 96.6 31.3C95.9 32.5 94.9 33.4 93.7 34.1C92.5 34.8 91 35.1 89.4 35.1H83.3V19.5V19.5ZM89.4 34C90.8 34 92.1 33.7 93.2 33.1C94.3 32.5 95.1 31.7 95.7 30.7C96.3 29.7 96.6 28.5 96.6 27.2C96.6 25.9 96.3 24.7 95.7 23.7C95.1 22.7 94.3 21.9 93.2 21.3C92.1 20.7 90.8 20.4 89.4 20.4H84.5V34H89.4ZM101.6 19.5H102.7V35H101.6V19.5ZM117.7 30.7H108.7L106.7 35.1H105.5L112.6 19.6H113.7L121 35H119.8L117.7 30.7V30.7ZM117.3 29.7L113.2 20.7L109.1 29.7H117.3V29.7ZM136.4 19.5V35H135.5L124.9 21.5V35H123.8V19.5H124.8L135.3 33V19.5H136.4Z"
          />
          <path
            d="M6.79999 61.8C5.09999 60.9 3.69999 59.6 2.79999 57.9C1.79999 56.3 1.29999 54.4 1.29999 52.3C1.29999 50.2 1.79999 48.4 2.79999 46.7C3.79999 45.1 5.09999 43.8 6.79999 42.8C8.49999 41.8 10.4 41.4 12.6 41.4C14.3 41.4 15.9 41.7 17.3 42.3C18.7 42.9 19.9 43.8 20.9 44.9L18.4 47.3C16.9 45.8 15 45 12.8 45C11.4 45 10.1 45.3 8.89999 45.9C7.79999 46.5 6.89999 47.4 6.19999 48.5C5.49999 49.6 5.19999 50.9 5.19999 52.3C5.19999 53.7 5.49999 55 6.19999 56.1C6.79999 57.2 7.69999 58.1 8.89999 58.7C10.1 59.3 11.3 59.6 12.8 59.6C15 59.6 16.9 58.8 18.4 57.1L20.9 59.5C19.9 60.6 18.7 61.5 17.3 62.1C15.9 62.7 14.3 63 12.6 63C10.4 63.2 8.49999 62.8 6.79999 61.8V61.8ZM24.7 41.9H28.6V59.6H39.6V62.9H24.7V41.9V41.9ZM42.7 41.9H46.6V62.9H42.7V41.9ZM71.6 62.9V48.9L64.7 60.4H63L56 49.2V63H52.3V42H55.5L63.9 56L72.1 42H75.3V63H71.6V62.9ZM94.7 58.1H84.1L82 63H78L87.5 42H91.3L100.8 63H96.7L94.7 58.1V58.1ZM93.4 55L89.4 45.8L85.5 55H93.4ZM106.7 45.2H99.7V41.9H117.6V45.2H110.6V62.9H106.7V45.2V45.2ZM136.4 59.7V63H120.6V42H136V45.3H124.5V50.8H134.7V54H124.5V59.8H136.4V59.7Z"
          />
          <path
            d="M26.3 70.7H27.4V86.2H26.3V70.7ZM45.5 70.7V86.2H44.6L34 72.8V86.3H32.9V70.7H33.9L44.5 84.2V70.7H45.5ZM51.8 85.8C50.8 85.4 50 84.9 49.4 84.3L49.9 83.5C50.4 84.1 51.2 84.5 52.1 84.9C53 85.3 54 85.4 55 85.4C56.5 85.4 57.6 85.1 58.3 84.6C59.1 84 59.4 83.3 59.4 82.4C59.4 81.7 59.2 81.2 58.8 80.7C58.4 80.2 57.9 80 57.3 79.7C56.8 79.5 56 79.3 55 79C53.9 78.7 52.9 78.4 52.3 78.2C51.6 77.9 51 77.5 50.5 77C50 76.5 49.8 75.7 49.8 74.8C49.8 74 50 73.4 50.4 72.7C50.8 72.1 51.4 71.6 52.2 71.2C53 70.8 54 70.6 55.3 70.6C56.2 70.6 57 70.7 57.8 71C58.6 71.3 59.3 71.6 60 72L59.6 72.9C59 72.5 58.3 72.1 57.5 71.9C56.8 71.7 56 71.6 55.3 71.6C53.9 71.6 52.8 71.9 52 72.5C51.3 73.1 50.9 73.8 50.9 74.7C50.9 75.4 51.1 75.9 51.5 76.4C51.9 76.9 52.4 77.1 53 77.4C53.6 77.6 54.4 77.9 55.4 78.1C56.5 78.4 57.4 78.7 58.1 78.9C58.8 79.2 59.4 79.6 59.8 80.1C60.3 80.6 60.5 81.4 60.5 82.3C60.5 83.1 60.3 83.7 59.9 84.4C59.5 85 58.9 85.5 58 85.9C57.2 86.3 56.1 86.5 54.9 86.5C53.9 86.4 52.8 86.2 51.8 85.8V85.8ZM67.2 71.8H61.6V70.8H73.9V71.8H68.3V86.3H67.2V71.8V71.8ZM76.7 70.7H77.8V86.2H76.7V70.7ZM86.2 71.8H80.6V70.8H92.9V71.8H87.3V86.3H86.2V71.8V71.8ZM96.9 84.7C95.8 83.6 95.3 81.9 95.3 79.7V70.8H96.4V79.7C96.4 81.6 96.8 83 97.7 84C98.6 85 99.8 85.4 101.5 85.4C103.1 85.4 104.4 84.9 105.3 84C106.2 83.1 106.6 81.6 106.6 79.7V70.8H107.7V79.7C107.7 81.9 107.2 83.5 106.1 84.7C105 85.8 103.5 86.4 101.5 86.4C99.5 86.4 98 85.8 96.9 84.7ZM115.6 71.8H110V70.8H122.3V71.8H116.7V86.3H115.6V71.8ZM135.9 85.2V86.2H125.2V70.7H135.6V71.7H126.4V77.8H134.7V78.8H126.4V85.2H135.9V85.2ZM238.9 19.5H240V34H248.9V35H238.8V19.5H238.9ZM251 18.8C251.2 19 251.3 19.2 251.3 19.5C251.3 19.6 251.3 19.8 251.2 20C251.2 20.2 251.1 20.3 251.1 20.6L250.2 23.6H249.4L250.1 20.5C249.9 20.4 249.7 20.3 249.6 20.2C249.5 20 249.4 19.8 249.4 19.6C249.4 19.3 249.5 19.1 249.7 18.9C249.9 18.7 250.1 18.6 250.4 18.6C250.7 18.6 250.8 18.6 251 18.8V18.8ZM255.2 19.5H256.3V35H255.2V19.5V19.5ZM274.4 19.5V35H273.5L262.9 21.5V35H261.8V19.5H262.8L273.3 33V19.5H274.4V19.5ZM280.7 34.5C279.7 34.1 278.9 33.6 278.3 33L278.8 32.2C279.3 32.8 280.1 33.2 281 33.6C281.9 34 282.9 34.1 283.9 34.1C285.4 34.1 286.5 33.8 287.2 33.3C287.9 32.8 288.3 32 288.3 31.1C288.3 30.4 288.1 29.9 287.7 29.4C287.3 29 286.8 28.7 286.2 28.4C285.6 28.2 284.8 27.9 283.8 27.7C282.7 27.4 281.8 27.1 281.1 26.9C280.4 26.6 279.8 26.2 279.3 25.7C278.8 25.1 278.6 24.4 278.6 23.5C278.6 22.7 278.8 22.1 279.2 21.4C279.6 20.8 280.2 20.3 281 19.9C281.8 19.5 282.8 19.3 284.1 19.3C285 19.3 285.8 19.4 286.6 19.7C287.4 20 288.1 20.3 288.8 20.7L288.4 21.6C287.8 21.2 287.1 20.8 286.3 20.6C285.5 20.4 284.8 20.3 284.1 20.3C282.7 20.3 281.6 20.6 280.8 21.2C280.1 21.8 279.7 22.5 279.7 23.4C279.7 24.1 279.9 24.6 280.3 25.1C280.7 25.5 281.2 25.8 281.8 26.1C282.4 26.4 283.2 26.6 284.2 26.8C285.3 27.1 286.2 27.4 286.9 27.6C287.6 27.9 288.2 28.3 288.6 28.8C289.1 29.3 289.3 30.1 289.3 31C289.3 31.8 289.1 32.4 288.7 33.1C288.3 33.8 287.7 34.2 286.8 34.6C286 35 284.9 35.2 283.7 35.2C282.8 35.1 281.7 34.9 280.7 34.5V34.5ZM296.1 20.5H290.5V19.5H302.8V20.5H297.2V35H296.1V20.5V20.5ZM305.6 19.5H306.7V35H305.6V19.5ZM315.1 20.5H309.5V19.5H321.8V20.5H316.2V35H315.1V20.5V20.5ZM325.8 33.4C324.7 32.3 324.2 30.6 324.2 28.4V19.5H325.3V28.4C325.3 30.3 325.7 31.7 326.6 32.7C327.5 33.7 328.7 34.1 330.4 34.1C332 34.1 333.3 33.6 334.2 32.7C335.1 31.8 335.5 30.3 335.5 28.4V19.5H336.6V28.4C336.6 30.6 336.1 32.2 335 33.4C333.9 34.5 332.4 35.1 330.4 35.1C328.4 35.1 326.9 34.6 325.8 33.4V33.4ZM344.5 20.5H338.9V19.5H351.2V20.5H345.6V35H344.5V20.5V20.5Z"
          />
          <path
            d="M239.1 61.8C237.4 60.9 236 59.6 235.1 57.9C234.1 56.3 233.6 54.4 233.6 52.3C233.6 50.2 234.1 48.4 235.1 46.7C236.1 45.1 237.4 43.8 239.1 42.8C240.8 41.8 242.7 41.4 244.9 41.4C246.6 41.4 248.2 41.7 249.6 42.3C251 42.9 252.2 43.8 253.2 44.9L250.7 47.3C249.2 45.7 247.3 44.8 245.1 44.8C243.7 44.8 242.4 45.1 241.2 45.7C240.1 46.3 239.2 47.2 238.5 48.3C237.9 49.4 237.5 50.7 237.5 52.1C237.5 53.5 237.8 54.8 238.5 55.9C239.1 57 240 57.9 241.2 58.5C242.4 59.1 243.6 59.4 245.1 59.4C247.3 59.4 249.2 58.6 250.7 56.9L253.2 59.3C252.2 60.4 251 61.3 249.6 61.9C248.2 62.5 246.6 62.8 244.9 62.8C242.7 63.2 240.8 62.8 239.1 61.8V61.8ZM257 41.9H260.9V59.6H271.9V62.9H257V41.9V41.9ZM275 41.9H278.9V62.9H275V41.9ZM303.9 62.9V48.9L297 60.4H295.3L288.4 49V62.8H284.7V41.8H287.9L296.3 55.8L304.5 41.8H307.7V62.8H303.9V62.9ZM326.9 58.1H316.4L314.3 63H310.3L319.8 42H323.6L333.1 63H329L326.9 58.1ZM325.6 55L321.6 45.8L317.7 55H325.6ZM339 45.2H332V41.9H349.9V45.2H342.9V62.9H339V45.2V45.2ZM352.8 41.9H356.7V62.9H352.8V41.9ZM384.7 65C384 65.8 383.2 66.4 382.2 66.9C381.3 67.3 380.3 67.5 379.1 67.5C377.7 67.5 376.3 67.2 375.1 66.5C373.9 65.8 372.5 64.7 371 63.1C369.1 62.9 367.3 62.4 365.8 61.4C364.3 60.4 363.1 59.2 362.2 57.6C361.3 56 360.9 54.3 360.9 52.4C360.9 50.4 361.4 48.5 362.4 46.9C363.4 45.2 364.7 44 366.5 43C368.3 42 370.2 41.6 372.3 41.6C374.4 41.6 376.4 42.1 378.1 43C379.8 43.9 381.2 45.2 382.2 46.9C383.2 48.5 383.7 50.4 383.7 52.5C383.7 54.2 383.4 55.7 382.7 57.1C382 58.5 381.1 59.7 379.9 60.7C378.7 61.7 377.3 62.4 375.8 62.8C376.4 63.4 377 63.9 377.5 64.2C378.1 64.5 378.7 64.6 379.3 64.6C380.7 64.6 381.9 64 382.9 62.9L384.7 65ZM365.8 56.2C366.4 57.3 367.3 58.2 368.4 58.8C369.5 59.4 370.8 59.7 372.2 59.7C373.6 59.7 374.9 59.4 376 58.8C377.1 58.2 378 57.3 378.6 56.2C379.2 55.1 379.6 53.8 379.6 52.4C379.6 51 379.3 49.7 378.6 48.6C377.9 47.5 377.1 46.6 376 46C374.9 45.4 373.6 45.1 372.2 45.1C370.8 45.1 369.5 45.4 368.4 46C367.3 46.6 366.4 47.5 365.8 48.6C365.2 49.7 364.8 51 364.8 52.4C364.8 53.8 365.2 55.1 365.8 56.2ZM390 60.8C388.4 59.2 387.6 56.8 387.6 53.8V41.9H391.5V53.6C391.5 57.7 393.3 59.8 396.9 59.8C400.4 59.8 402.2 57.7 402.2 53.6V41.9H406V53.8C406 56.8 405.2 59.2 403.6 60.8C402 62.4 399.7 63.3 396.8 63.3C393.9 63.3 391.6 62.4 390 60.8V60.8ZM427.3 59.7V63H411.5V42H426.9V45.3H415.4V50.8H425.6V54H415.4V59.8H427.3V59.7Z"
          />
          <path
            d="M235.5 70.7H241.6C243.2 70.7 244.6 71 245.9 71.7C247.2 72.4 248.1 73.3 248.8 74.5C249.5 75.7 249.8 77 249.8 78.5C249.8 80 249.5 81.3 248.8 82.5C248.1 83.7 247.1 84.6 245.9 85.3C244.7 86 243.2 86.3 241.6 86.3H235.5V70.7ZM241.5 85.2C242.9 85.2 244.2 84.9 245.3 84.3C246.4 83.7 247.2 82.9 247.8 81.9C248.4 80.9 248.7 79.7 248.7 78.4C248.7 77.1 248.4 75.9 247.8 74.9C247.2 73.9 246.4 73.1 245.3 72.5C244.2 71.9 242.9 71.6 241.5 71.6H236.6V85.1H241.5V85.2ZM255.3 84.7C254.2 83.6 253.7 81.9 253.7 79.7V70.8H254.8V79.7C254.8 81.6 255.2 83 256.1 84C257 85 258.2 85.4 259.9 85.4C261.5 85.4 262.8 84.9 263.7 84C264.6 83.1 265 81.6 265 79.7V70.8H266.1V79.7C266.1 81.9 265.6 83.5 264.5 84.7C263.4 85.8 261.9 86.4 259.9 86.4C257.9 86.4 256.4 85.8 255.3 84.7V84.7ZM279.5 85.4C278.3 84.7 277.3 83.8 276.6 82.6C275.9 81.4 275.5 80.1 275.5 78.6C275.5 77.1 275.9 75.8 276.6 74.6C277.3 73.4 278.3 72.5 279.5 71.8C280.7 71.1 282.1 70.8 283.6 70.8C284.7 70.8 285.8 71 286.7 71.3C287.6 71.7 288.5 72.2 289.1 72.9L288.4 73.6C287.2 72.4 285.6 71.8 283.6 71.8C282.3 71.8 281.1 72.1 280.1 72.7C279 73.3 278.2 74.1 277.6 75.1C277 76.1 276.7 77.3 276.7 78.6C276.7 79.9 277 81 277.6 82.1C278.2 83.1 279 84 280.1 84.5C281.2 85.1 282.3 85.4 283.6 85.4C285.5 85.4 287.1 84.8 288.4 83.5L289.1 84.2C288.4 84.9 287.6 85.4 286.7 85.8C285.7 86.2 284.7 86.4 283.6 86.4C282.1 86.4 280.7 86 279.5 85.4V85.4ZM302.1 81.9H293.1L291.1 86.3H289.9L297 70.8H298.1L305.2 86.3H304L302.1 81.9ZM301.7 80.9L297.6 71.9L293.5 80.9H301.7V80.9ZM320.8 70.7V86.2H319.9L309.3 72.7V86.2H308.2V70.7H309.2L319.8 84.2V70.7H320.8ZM335.8 81.9H326.8L324.8 86.3H323.6L330.7 70.8H331.8L338.9 86.3H337.7L335.8 81.9V81.9ZM335.3 80.9L331.2 71.9L327.1 80.9H335.3V80.9ZM341.8 70.7H347.9C349.5 70.7 350.9 71 352.2 71.7C353.5 72.4 354.4 73.3 355.1 74.5C355.8 75.7 356.1 77 356.1 78.5C356.1 80 355.8 81.3 355.1 82.5C354.4 83.7 353.4 84.6 352.2 85.3C351 86 349.5 86.3 347.9 86.3H341.8V70.7ZM347.8 85.2C349.2 85.2 350.5 84.9 351.6 84.3C352.7 83.7 353.5 82.9 354.1 81.9C354.7 80.9 355 79.7 355 78.4C355 77.1 354.7 75.9 354.1 74.9C353.5 73.9 352.7 73.1 351.6 72.5C350.5 71.9 349.2 71.6 347.8 71.6H342.9V85.1H347.8V85.2ZM369.5 81.9H360.5L358.5 86.3H357.3L364.4 70.8H365.5L372.6 86.3H371.4L369.5 81.9V81.9ZM369.1 80.9L365 71.9L360.9 80.9H369.1V80.9Z"
          />
        </svg>
      </a>
    </div>

    <div class="site-footer-social">
      <ul class="social-link-menu">
        <li class="social-item">
          <a
            class="social-link"
            href="https://twitter.com/440Megatonnes"
            target="_blank"
          >
            <svg
              class="social-icon"
              role="img"
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Twitter</title>
              <path
                d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"
              />
            </svg>
          </a>
        </li>
      </ul>
    </div>

    <div class="site-footer-disclaimer">
      {#if langHandler.locale == "fr"}
      <p>
        440 mégatonnes est un projet de l’Institut climatique du Canada, publié sous une licence internationale Creative Commons <a
          href="https://creativecommons.org/licenses/by/4.0/"
          target="_blank"
          rel="noopener">BY 4.0</a
        >. Vous pouvez reproduire et utiliser ce contenu tout ou en partie, à condition d’indiquer le crédit approprié, de fournir un lien vers l’original et d’indiquer si des changements ont été apportés.
      </p>
      <p>
        Nous reconnaissons et respectons la souveraineté des peuples et des communautés Autochtones sur les terres desquels nous travaillons.
      </p>
      {:else}
      <p>
        440 Megatonnes is a project of the Canadian Climate Institute, and is
        published under a Creative Commons <a
          href="https://creativecommons.org/licenses/by/4.0/"
          target="_blank"
          rel="noopener">BY 4.0</a
        > international license. You are welcome to reproduce and repurpose material
        in whole or part, as long as you give appropriate credit, provide a link
        to the original, and indicate if changes were made.
      </p>
      <p>
        We recognize and respect the sovereignty of the Indigenous Peoples and
        communities on whose land our work takes place.
      </p>
      {/if}
    </div>
  </div>
</footer>

<style>
  footer {
    --font-sans-serif: "Montserrat", sans-serif;
    --font-condensed: "Oswald", sans-serif;
    --font-serif: "PT Serif", serif;
    --color-txt: #4a4a4a;
    --color-txt-inv: #ffffff;
    --color-primary: #43aa8b;
    --color-primary-muted: #86aca6;
    --color-primary-light: #deede8;
    --color-primary-dark: #004845;
    --color-footer: #627e83;
    --header-height: 4.375rem;
    --header-height-mobile: 3.125rem;
    --layout-width: 122em;
  }

  footer {
    color: var(--color-txt);
    font-family: var(--font-sans-serif);
    line-height: 1.3;
  }

  /* From staging site */
  .u-sr-only:not(:focus):not(:active) {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  /*! CSS Used from: https://440-megatonnes.flywheelsites.com/wp-includes/css/dist/block-library/style.min.css?ver=6.0.3 ; media=all */
  @media all {
    ul {
      box-sizing: border-box;
    }
  }
  /*! CSS Used from: https://440-megatonnes.flywheelsites.com/wp-content/themes/440-megatonnes/public/main.css?ver=1.5.1 ; media=screen */
  @media screen {
    a {
      background-color: transparent;
    }
    *,
    :after,
    :before {
      box-sizing: inherit;
    }
    .layout-wrapper {
      margin: 0 auto;
      max-width: var(--layout-width);
      width: calc(100% - 4rem);
    }
    .site-footer {
      --_max-width: 39rem;
      --_font-size: 0.75rem;
      background-color: var(--color-footer);
      color: var(--color-txt-inv);
      font-size: var(--_font-size);
      /* margin-top: 3.75rem; */
      position: relative;
      z-index: 1;
    }
    .site-footer a {
      color: var(--color-link);
    }
    .site-footer-inner {
      --_vertical-padding: 2rem;
      padding-block: 2rem;
      position: relative;
    }
    .site-footer-logo {
      --_logo-size: 3.75rem;
      display: block;
      height: var(--_logo-size);
      margin-block-end: 1.5rem;
      margin-block-start: calc(
        var(--_vertical-padding) * -1 - var(--_logo-size) / 2 - 0.125rem
      );
      width: var(--_logo-size);
    }
    @media (min-width: 920px) {
      .site-footer-logo {
        left: 0;
        margin-block-start: 0;
        position: absolute;
        top: 0;
        transform: translateY(-50%);
      }
    }
    @media (min-width: 750px) {
      .site-footer-logo {
        --_logo-size: 6.5625rem;
      }
    }
    .site-footer-menu {
      --_vertical-gap: 0.4375rem;
      --_horizontal-gap: 4.375rem;
      display: grid;
      font-size: inherit;
      font-weight: 600;
      gap: 0 var(--_horizontal-gap);
      grid-auto-flow: row;
      grid-template-columns: repeat(auto-fit, minmax(0, max-content));
      grid-template-rows: auto;
      line-height: 1.25;
      list-style: none;
      margin-inline: auto;
      max-width: var(--_max-width);
      padding: 0;
      width: 100%;
    }
    .site-footer-menu a {
      color: inherit;
      text-decoration: none;
    }
    .site-footer-menu .menu-item {
      letter-spacing: -1.5%;
      text-transform: uppercase;
    }
    .site-footer-menu .sub-menu {
      display: flex;
      flex-direction: column;
      gap: var(--_vertical-gap) 0;
      list-style: none;
      margin-block-start: var(--_vertical-gap);
      padding: 0;
    }
    .site-footer-disclaimer {
      font-family: var(--font-serif);
      font-size: var(--_font-size);
      font-weight: 400;
      letter-spacing: -1.5%;
      line-height: 1.25;
      margin-block-start: 2rem;
      margin-inline: auto;
      max-width: var(--_max-width);
      width: 100%;
    }
    .site-logo {
      height: var(--_logo-size), 6.5625rem;
      width: var(--_logo-size), 6.5625rem;
    }
  }

  /* Hide for dashboard -- missing new CSS for proper logo formatting, anyway.*/
  .site-footer-logo, .site-footer-social, .site-footer-cci-link {
      display: none;
    }
</style>
